const getSlideUrl = (id: string) => {
  return "/slides/html/html1/" + id + ".html";
};

export default getSlideUrl;
